import type {
  DocsSiteEventType,
  EventParams,
  EventParamsMap,
  EventTrackingOptions,
} from '../constant/Analytics';
import { isServer } from './ssr';

const isEventTrackingInitialized = () => {
  return typeof window !== 'undefined' && window.eventTracking;
};

export function gaReport<T extends DocsSiteEventType>(
  eventName: T,
  eventParams: EventParamsMap[T],
  options?: EventTrackingOptions,
): void;

export function gaReport(
  eventName: string,
  eventParams?: EventParams,
  options?: EventTrackingOptions,
): void {
  if (isServer) {
    return;
  }

  if (!isEventTrackingInitialized()) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Event tracking is not initialized yet');
    }
    return;
  }

  const finalOptions = options || { specificPlatform: 'ga' };
  const timestamp = Date.now();
  const enrichedParams = {
    ...eventParams,
    timestamp,
  };

  try {
    window.eventTracking.report(eventName, enrichedParams, finalOptions);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to report event:', error);
    }
  }
}

export const createGaReporter = <T extends DocsSiteEventType>(
  defaultParams: Partial<EventParamsMap[T]>,
) => {
  return (
    eventName: T,
    eventParams?: Partial<EventParamsMap[T]>,
    options?: EventTrackingOptions,
  ) => {
    gaReport(eventName, { ...defaultParams, ...eventParams } as EventParamsMap[T], options);
  };
};
